import { render, staticRenderFns } from "./SegmentPreview.vue?vue&type=template&id=b580b75a&"
import script from "./SegmentPreview.vue?vue&type=script&lang=js&"
export * from "./SegmentPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports